import axios from 'axios';
import { isArray } from 'lodash';
import {
  DEFAULT_MESSAGE_UNEXPECTED_ERROR,
  DAILY_REPORT_FOLDER_NAME
} from '../const/Const';
import { createPictureFolder } from '../apicalls/cloudFile';
import { createPictureByUser } from '../utils/common';
import { check } from 'prettier';

export const getDailyReportList = (
  construct_id?: number,
  worker_name?: string,
  report_division?: number | null,
  start_date?: string | null,
  end_date?: string | null,
  has_cost_up?: boolean | null,
  has_cost_down?: boolean | null,
  has_images?: boolean | null,
  page?: number,
  display_limit?: number
) => {
  return axios
    .get(`/api/v1/daily-report`, {
      params: {
        construct_id,
        worker_name,
        report_division,
        start_date,
        end_date,
        has_cost_up,
        has_cost_down,
        has_images,
        page,
        display_limit
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getDailyReportDetail = (dailyReportId: number) => {
  return axios
    .get(`/api/v1/daily-report/${dailyReportId}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createDailyReport = (
  work_day: string,
  construct_id: number,
  report_detail: string,
  photoSyncEnabled: boolean,
  upload_files?: File[],
  cost_up_factor?: string,
  cost_up_amount?: number | null,
  cost_down_factor?: string,
  cost_down_amount?: number | null
) => {
  // マルチパートで送信するためFormDataを使用
  const formData = new FormData();
  // 必須項目
  formData.append('work_day', work_day);
  formData.append('construct_id', String(construct_id));
  formData.append('report_detail', report_detail);
  if (cost_up_factor) formData.append('cost_up_factor', cost_up_factor);
  if (cost_up_amount) formData.append('cost_up_amount', String(cost_up_amount));
  if (cost_down_factor) formData.append('cost_down_factor', cost_down_factor);
  if (cost_down_amount)
    formData.append('cost_down_amount', String(cost_down_amount));
  if (upload_files && isArray(upload_files)) {
    upload_files.forEach(file => {
      formData.append('upload_file', file);
    });
  }

  const uploadPictures = (folder_id: number) => {
    if (upload_files && isArray(upload_files)) {
      upload_files.forEach(file => {
        const data = new FormData();
        const formattedWorkDay = work_day.replace(/\//g, '-');
        data.append('upload_file', file as any);
        data.append('construct_id', String(construct_id));
        data.append('shooting_date', formattedWorkDay);
        data.append('picture_folder_id', String(folder_id));
        data.append('description', '');

        // 写真をアップロード
        createPictureByUser(data);
      });
    }
  };

  if (photoSyncEnabled === true) {
    const params = {
      construct_id: construct_id,
      name: DAILY_REPORT_FOLDER_NAME
    };
    createPictureFolder(params)
      .then(res => {
        if (res.error) {
          return Promise.reject(res.error);
        }
        const createdFolderId = res.folder_id;
        // フォルダIDを取得後にDAILY_REPORT_FOLDER_NAMEへのアップロード処理を行う
        uploadPictures(createdFolderId);
      })
      .catch(error => {
        alert('エラーが発生しました。' + error);
      });
  }

  return axios
    .post(`/api/v1/daily-report/create`, formData, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createDailyReportForWorkers = (
  work_day: string,
  construct_id: number,
  photoSyncEnabled: boolean,
  company_name: string,
  worker_name: string,
  report_detail: string,
  upload_files?: File[],
  site_process_id?: number | null
) => {
  // マルチパートで送信するためFormDataを使用
  const formData = new FormData();
  // 必須項目
  formData.append('work_day', work_day);
  formData.append('construct_id', String(construct_id));
  formData.append('company_name', company_name);
  formData.append('worker_name', worker_name);
  formData.append('report_detail', report_detail);
  if (site_process_id)
    formData.append('site_process_id', String(site_process_id));
  if (upload_files && isArray(upload_files)) {
    upload_files.forEach(file => {
      formData.append('upload_file', file);
    });
  }

  const uploadPictures = (folder_id: number) => {
    if (upload_files && isArray(upload_files)) {
      upload_files.forEach(file => {
        const data = new FormData();
        const formattedWorkDay = work_day.replace(/\//g, '-');
        data.append('upload_file', file as any);
        data.append('construct_id', String(construct_id));
        data.append('shooting_date', formattedWorkDay);
        data.append('picture_folder_id', String(folder_id));
        data.append('description', '');

        // 写真をアップロード
        createPictureByUser(data);
      });
    }
  };

  if (photoSyncEnabled === true) {
    const params = {
      construct_id: construct_id,
      name: DAILY_REPORT_FOLDER_NAME
    };
    createPictureFolder(params)
      .then(res => {
        if (res.error) {
          return Promise.reject(res.error);
        }
        const createdFolderId = res.folder_id;
        // フォルダIDを取得後にDAILY_REPORT_FOLDER_NAMEへのアップロード処理を行う
        uploadPictures(createdFolderId);
      })
      .catch(error => {
        alert('エラーが発生しました。' + error);
      });
  }

  return axios
    .post(`/api/v1/daily-report/field-worker/create`, formData, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getDailyReportAuthByUrl = (token?: string | null) => {
  return axios
    .get(`/api/v1/daily-report/url/authenticate`, {
      params: {
        token
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createDailyReportUrl = (
  construct_id: number,
  expiration_datetime: string | null
) => {
  return axios
    .post(
      `/api/v1/daily-report/url/create`,
      {
        construct_id,
        expiration_datetime
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const exportDailyReportImage = (daily_report_id: number) => {
  return axios
    .post(
      `/api/v1/daily-report/export/image`,
      {
        daily_report_id: daily_report_id
      },
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        // エラーの場合はBlobをJSONに変換→オブジェクトに変換する
        return err.response.data.text().then((text: any) => {
          const data = JSON.parse(text);
          if (
            data.error &&
            data.error === 'Missing cookie access_token_cookie'
          ) {
            return 'Not logged in!';
          } else if (data.error) {
            return data;
          } else {
            return DEFAULT_MESSAGE_UNEXPECTED_ERROR;
          }
        });
      } else {
        return err.response;
      }
    });
};

export const updateDailyReport = (
  daily_report_id: number,
  work_day: string,
  construct_id: number,
  report_detail: string,
  upload_files?: File[],
  delete_target_files?: number[],
  cost_up_factor?: string,
  cost_up_amount?: number | null,
  cost_down_factor?: string,
  cost_down_amount?: number | null
) => {
  // マルチパートで送信するためFormDataを使用
  const formData = new FormData();
  // 必須項目
  formData.append('daily_report_id', String(daily_report_id));
  formData.append('work_day', work_day);
  formData.append('construct_id', String(construct_id));
  formData.append('report_detail', report_detail);
  // 非必須項目
  if (cost_up_factor) formData.append('cost_up_factor', cost_up_factor);
  if (cost_up_amount) formData.append('cost_up_amount', String(cost_up_amount));
  if (cost_down_factor) formData.append('cost_down_factor', cost_down_factor);
  if (cost_down_amount)
    formData.append('cost_down_amount', String(cost_down_amount));
  if (upload_files && isArray(upload_files)) {
    upload_files.forEach(file => {
      formData.append('upload_file', file);
    });
  }
  if (delete_target_files && isArray(delete_target_files)) {
    delete_target_files.forEach(id => {
      formData.append('delete_target_file', String(id));
    });
  }

  return axios
    .put(`/api/v1/daily-report/update`, formData, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteDailyReport = (daily_report_id: number) => {
  return axios
    .post(
      `/api/v1/daily-report/delete`,
      {
        daily_report_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
